const styles = {
  layout: {
    display: "flex",
    gap: 20,
    height: "calc(100vh - 220px)",
    minHeight: 420,
  },

  /* --- sidebar --- */
  sidebar: {
    width: 260,
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    padding: 16,
    boxSizing: "border-box",
    overflowY: "auto",
  },
  sidebarGroupTitle: {
    fontSize: 13,
    fontWeight: 700,
    color: "var(--ink-faint)",
    textTransform: "uppercase",
    letterSpacing: 0.5,
    margin: "10px 0 8px",
  },
  sidebarEmpty: {
    fontSize: 13,
    color: "var(--ink-faint)",
    margin: "0 0 10px",
  },
  sidebarList: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  sidebarItem: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    width: "100%",
    padding: "8px 10px",
    borderRadius: 10,
    border: "none",
    background: "transparent",
    cursor: "pointer",
    textAlign: "left",
    fontFamily: "inherit",
    fontSize: 14,
    color: "var(--ink)",
  },
  sidebarItemActive: {
    background: "var(--bg-page)",
    fontWeight: 700,
  },
  sidebarAvatar: {
    width: 30,
    height: 30,
    borderRadius: "50%",
    background: "var(--accent-color)",
    border: "1.5px solid var(--ink)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: 13,
    color: "#FFFDF8",
    flexShrink: 0,
  },
  sidebarAvatarImg: {
    width: 30,
    height: 30,
    borderRadius: "50%",
    border: "1.5px solid var(--ink)",
    objectFit: "cover",
    flexShrink: 0,
    display: "block",
  },
  sidebarAvatarWrap: {
    position: "relative",
    flexShrink: 0,
    display: "inline-flex",
  },
  sidebarItemName: {
    flex: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  unreadBadge: {
    flexShrink: 0,
    minWidth: 20,
    height: 20,
    padding: "0 6px",
    borderRadius: 10,
    background: "var(--accent-color)",
    color: "#FFFDF8",
    fontSize: 11,
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  onlineDot: {
    position: "absolute",
    bottom: -1,
    right: -1,
    width: 10,
    height: 10,
    borderRadius: "50%",
    background: "#4CAF50",
    border: "2px solid var(--card-bg, #FFFDF8)",
  },
  onlineDotOffline: {
    position: "static",
    border: "none",
    background: "var(--ink-faint)",
    marginRight: 6,
  },
  // A separate flat (non-absolute) dot for the chat-window header, next to
  // the target's name — the sidebar's onlineDot is positioned absolutely
  // relative to sidebarAvatarWrap, which the header doesn't have.
  headerOnlineDot: {
    display: "inline-block",
    width: 9,
    height: 9,
    borderRadius: "50%",
    background: "#4CAF50",
    marginRight: 6,
    flexShrink: 0,
  },
  headerOnlineDotOffline: {
    background: "var(--ink-faint)",
  },

  /* --- chat window --- */
  window: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    padding: 0,
    overflow: "hidden",
  },
  windowHeader: {
    padding: "12px 20px",
    borderBottom: "2px solid var(--bg-page)",
    flexShrink: 0,
  },
  windowHeaderTitleRow: {
    display: "flex",
    alignItems: "center",
    fontWeight: 700,
    fontSize: 16,
    color: "var(--ink)",
  },
  windowHeaderStatus: {
    fontSize: 12,
    color: "var(--ink-faint)",
    height: 16,
    marginTop: 2,
  },
  windowEmpty: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: 24,
    color: "var(--ink-faint)",
    fontSize: 15,
  },
  messageList: {
    flex: 1,
    overflowY: "auto",
    padding: "16px 20px",
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  // Outer wrapper adds the sender's avatar next to "their" messages — mine
  // has no avatar (I already know it's me), so it's just the column itself,
  // right-aligned.
  messageOuter: {
    display: "flex",
    maxWidth: "70%",
  },
  messageOuterMine: {
    alignSelf: "flex-end",
  },
  messageOuterOther: {
    alignSelf: "flex-start",
    alignItems: "flex-end",
    gap: 8,
  },
  messageAvatarImg: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    border: "1.5px solid var(--ink)",
    objectFit: "cover",
    flexShrink: 0,
  },
  messageAvatarPlaceholder: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    background: "var(--accent-color)",
    border: "1.5px solid var(--ink)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    fontWeight: 700,
    color: "#FFFDF8",
    flexShrink: 0,
  },
  messageRow: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },
  messageRowMine: {
    alignSelf: "flex-end",
    alignItems: "flex-end",
  },
  messageRowOther: {
    alignSelf: "flex-start",
    alignItems: "flex-start",
  },
  messageSender: {
    fontSize: 12,
    color: "var(--ink-faint)",
    margin: "0 4px 3px",
  },
  bubble: {
    padding: "9px 14px",
    borderRadius: 16,
    fontSize: 14,
    lineHeight: 1.5,
    wordBreak: "break-word",
    border: "2px solid var(--ink)",
  },
  bubbleMine: {
    background: "var(--accent-color)",
    color: "#FFFDF8",
    borderBottomRightRadius: 4,
  },
  bubbleOther: {
    background: "var(--bg-page)",
    color: "var(--ink)",
    borderBottomLeftRadius: 4,
  },
  messageTime: {
    fontSize: 11,
    color: "var(--ink-faint)",
    margin: "3px 4px 0",
  },

  /* --- attachments --- */
  attachmentImage: {
    display: "block",
    maxWidth: 240,
    maxHeight: 240,
    borderRadius: 12,
    border: "2px solid var(--ink)",
    objectFit: "cover",
  },
  attachmentFileChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "8px 12px",
    borderRadius: 12,
    border: "2px solid var(--ink)",
    background: "var(--bg-page)",
    color: "var(--ink)",
    textDecoration: "none",
    fontSize: 13,
    maxWidth: 220,
  },
  attachmentFileIcon: {
    fontSize: 16,
    flexShrink: 0,
  },
  attachmentFileName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  /* --- composer --- */
  composerWrap: {
    borderTop: "2px solid var(--bg-page)",
    flexShrink: 0,
  },
  composerPreview: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 16px 0",
  },
  composerPreviewImage: {
    width: 44,
    height: 44,
    borderRadius: 8,
    border: "2px solid var(--ink)",
    objectFit: "cover",
  },
  composerPreviewMeta: {
    fontSize: 12,
    color: "var(--ink-faint)",
    flex: 1,
  },
  composerPreviewRemove: {
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: 14,
    color: "var(--ink-faint)",
    padding: 4,
  },
  composer: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: 16,
  },
  attachBtn: {
    background: "var(--bg-page)",
    color: "var(--ink)",
    padding: "10px 14px",
    fontSize: 16,
    flexShrink: 0,
  },
  composerInput: {
    flex: 1,
  },
  sendBtn: {
    background: "var(--accent-color)",
    color: "#FFFDF8",
    padding: "10px 22px",
    fontSize: 15,
    flexShrink: 0,
  },
};

export default styles;
